import { gql } from "@apollo/client"
import type { CountryIntelligenceRulesProbation } from "@oysterhr/schema"
import { ProbationRulesFragment } from "../../hooks/useKBIntegration/fragments"
import type { AdvisorKnowledgeBase } from "../../types"
import useSubdivisionName from "~/app/queries/useSubdivisionName"
import { StatutoryMessage, CustomaryMessage, RecommendedMessage } from "./_helpers"

export type Module = AdvisorKnowledgeBase<{
  isoAlpha2Code: string
  statutory: CountryIntelligenceRulesProbation[]
  recommended: CountryIntelligenceRulesProbation[]
  customary: CountryIntelligenceRulesProbation[]
}>

export const queryFragment: Module["queryFragment"] = gql`
  fragment kbProbationPeriod on CountryIntelligence {
    isoAlpha2Code
    probationRules {
      ...ProbationRulesFragment
    }
    statutory: probationRules(oysterScore: STATUTORY) {
      ...ProbationRulesFragment
    }
    recommended: probationRules(oysterScore: RECOMMENDED) {
      ...ProbationRulesFragment
    }
    customary: probationRules(oysterScore: CUSTOMARY) {
      ...ProbationRulesFragment
    }
  }
  ${ProbationRulesFragment}
`

export const TranslationComponent: Module["TranslationComponent"] = ({ data, input }) => {
  const { statutory, recommended, customary, isoAlpha2Code } = data
  const subdivisionName = useSubdivisionName(isoAlpha2Code || "", input?.subdivisionCode || "")

  if (!statutory?.length && !recommended?.length) {
    throw new Error("No probation period data found")
  }

  return (
    <>
      {!!statutory?.length && (
        <StatutoryMessage
          statutory={statutory}
          countryCode={isoAlpha2Code}
          subdivisionName={subdivisionName}
        />
      )}
      {!!customary?.length && (
        <CustomaryMessage customary={customary} countryCode={isoAlpha2Code} />
      )}
      {!!recommended?.length && (
        <RecommendedMessage recommended={recommended} countryCode={isoAlpha2Code} />
      )}
    </>
  )
}

export const checkDataPresence: Module["checkDataPresence"] = (data): boolean => {
  return !!(data.statutory?.length || data.recommended?.length || data.customary?.length)
}
